import axios from 'axios'

let token           = localStorage.getItem('accessToken')
 
const axiosInstance =  axios.create({
  headers: {
    'Authorization':`${ token }`,
    'Content-Type': 'application/json'
  },
  baseURL: process.env.API_DEXX
})

axiosInstance.interceptors.request.use(
  config => {
    let token = localStorage.getItem('accessToken')
    if (token) {
        config.headers['Authorization'] = token;
    }
    config.headers['Content-Type'] = 'application/json';
   
    return config;
  },
  error => {
      Promise.reject(error)
  }
);
  
export default axiosInstance